// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-link{font-size:14px;margin-bottom:2px}.notification-link:hover{border-bottom:1px solid rgba(0,0,0,0) !important}", ""]);
// Exports
module.exports = exports;
